import { Request, Requests, RequestStatus } from "@/models/Request.js"
import firebase from 'firebase/app'

class RequestRepository {
  constructor(client) {
    this.collection = client.collection('requests')
    this.snapShotOptions = { serverTimestamps : 'estimate' }
  }

  async create(receiverId, senderId, studentId) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const docRef = await this.collection.doc()
    const request = new Request(
      docRef.id,
      receiverId,
      senderId,
      studentId,
      RequestStatus.inRequest,
      timestamp,
      timestamp
    )
    const object = request.toObject()
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRequestFromFireStoreData(result.id, data)
  }

  async find (id) {
    const result = await this.collection.doc(id).get()
    const data = result.data(this.snapShotOptions)
    if (data) {
      return createRequestFromFireStoreData(id, data)
    } else {
      return null
    }
  }

  async createAtOnce(receiverId, senderId, studentIds) {
    const arr = await Promise.all(studentIds.map(async studentId => {
      return await this.create(receiverId, senderId, studentId)
    }))
    return createRequests(arr)
  }

  async listOfInRequest(receiverId) {
    const snapShot = await this.collection.where("receiverId", "==", receiverId).where("status", "==", RequestStatus.inRequest).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createRequestFromFireStoreData(doc.id, doc.data()))
    })
    return createRequests(arr)
  }

  async listOfAllRequests(senderId) {
    const snapShot = await this.collection.where("senderId", "==", senderId).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createRequestFromFireStoreData(doc.id, doc.data()))
    })
    return createRequests(arr)
  }

  async listOfDenied(receiverId) {
    const snapShot = await this.collection.where("receiverId", "==", receiverId).where("status", "==", RequestStatus.denied).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createRequestFromFireStoreData(doc.id, doc.data()))
    })
    return createRequests(arr)
  }

  async query (receiverId, status) {
    const snapShot = await this.collection.where("receiverId", "==", receiverId).where("status", "==", status).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createRequestFromFireStoreData(doc.id, doc.data()))
    })
    return arr
  }

  async listOfAgreed(studentId) {
    const snapShot = await this.collection.where("studentId", "==", studentId).where("status", "==", Request.accepted).get()
    let arr = []
    snapShot.forEach(doc => {
      arr.push(createRequestFromFireStoreData(doc.id, doc.data()))
    })
    return createRequests(arr)
  }

  async update(request) {
    request.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
    const object = request.toObject()
    const docRef = await this.collection.doc(request.id)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRequestFromFireStoreData(object.id, data)
  }

  async updateStatus(req, newStatus) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const object = req.toObject()
    object.data.updatedAt = timestamp
    object.data.status  = newStatus
    const docRef = await this.collection.doc(object.id)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRequestFromFireStoreData(object.id, data)
  }

  async accept(req) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const object = req.toObject()
    object.data.updatedAt = timestamp
    object.data.status  = RequestStatus.accepted
    const docRef = await this.collection.doc(object.id)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRequestFromFireStoreData(object.id, data)
  }

  async deny(req) {
    const timestamp = firebase.firestore.FieldValue.serverTimestamp()
    const object = req.toObject()
    object.data.updatedAt = timestamp
    object.data.status  = RequestStatus.denied
    const docRef = await this.collection.doc(object.id)
    docRef.set(object.data)
    const result = await docRef.get()
    const data = result.data(this.snapShotOptions)
    return createRequestFromFireStoreData(object.id, data)
  }

  async delete(req) {
    return await this.collection.doc(req.id).delete()
  }
}

const createRequestFromFireStoreData = (id, data) => {
  return new Request(
    id,
    data.receiverId,
    data.senderId,
    data.studentId,
    data.status,
    data.createdAt.toDate(),
    data.updatedAt.toDate()
  )
}

const createRequests = (arr) => {
  return new Requests(arr)
}

export { RequestRepository }